/**
 * User Service API
 * Contains API functions for user management operations
 */

const API_URL: string | undefined = process.env.REACT_APP_API_URL;

export interface ResetPasswordResponse {
  detail: string;
  new_password: string;
  email: string;
}

/**
 * Reset password for a user
 * @param userId - The ID of the user whose password should be reset
 * @returns Promise with the response data including new password
 * @throws Error if the request fails
 */
export const resetUserPassword = async (userId: string): Promise<ResetPasswordResponse> => {
  try {
    const response = await fetch(`${API_URL}/profile/users/${userId}/reset_password`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const errorMessage = typeof errorData.detail === 'string' 
        ? errorData.detail 
        : JSON.stringify(errorData.detail || errorData);
      throw new Error(errorMessage || response.statusText || "Failed to reset password");
    }

    return await response.json();
  } catch (error) {
    console.error("Error resetting user password:", error);
    throw error;
  }
};;
